import { Controller } from "@hotwired/stimulus"

// Manages the language blocks on the company profile Languages tab:
// adding a locale clones the template, removing one frees the locale
// up again in the add-select.
export default class extends Controller {
  static targets = ["container", "template", "select", "defaultSelect", "emptyState"]

  add(event) {
    event.preventDefault()
    const select = this.selectTarget
    const code = select.value
    if (!code) return
    select.value = ""
    if (this.hasDefaultSelectTarget && this.defaultSelectTarget.value === code) return
    if (this.containerTarget.querySelector(`[data-locale="${code}"]`)) return

    const option = select.querySelector(`option[value="${code}"]`)
    const name = option ? option.textContent : code
    const html = this.templateTarget.innerHTML
      .replaceAll("LOCALE_NAME", name)
      .replaceAll("LOCALE", code)
    this.containerTarget.insertAdjacentHTML("beforeend", html)
    if (option) {
      option.disabled = true
      option.hidden = true
    }
    this.toggleEmptyState()
  }

  remove(event) {
    event.preventDefault()
    const block = event.currentTarget.closest("[data-locale]")
    if (!block) return
    const option = this.selectTarget.querySelector(`option[value="${block.dataset.locale}"]`)
    if (option) {
      option.disabled = false
      option.hidden = false
    }
    block.remove()
    this.toggleEmptyState()
  }

  toggleEmptyState() {
    if (!this.hasEmptyStateTarget) return
    const hasBlocks = this.containerTarget.querySelector("[data-locale]")
    this.emptyStateTarget.style.display = hasBlocks ? "none" : ""
  }
}
